import { render, staticRenderFns } from "./CollectionRecordAddTable.vue?vue&type=template&id=e11d0c06&scoped=true"
import script from "./CollectionRecordAddTable.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddTable.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddTable.vue?vue&type=style&index=0&id=e11d0c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11d0c06",
  null
  
)

export default component.exports